import { apiRequest } from "@/config/api";

const ANALYTICS_SESSION_KEY = "mr_analytics_session_id";
const ANALYTICS_LANDING_KEY = "mr_analytics_landing_path";

const getUrlParams = () => {
  if (typeof window === "undefined") return new URLSearchParams();
  return new URLSearchParams(window.location.search);
};

export const getAnalyticsSessionId = () => {
  if (typeof window === "undefined") return "";
  try {
    const stored = localStorage.getItem(ANALYTICS_SESSION_KEY);
    if (stored) return stored;
    const created = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(ANALYTICS_SESSION_KEY, created);
    return created;
  } catch {
    return `session-${Date.now()}`;
  }
};

export const getAnalyticsLandingPath = () => {
  if (typeof window === "undefined") return "/";
  try {
    const stored = localStorage.getItem(ANALYTICS_LANDING_KEY);
    if (stored) return stored;
    const current = `${window.location.pathname}${window.location.search}`;
    localStorage.setItem(ANALYTICS_LANDING_KEY, current);
    return current;
  } catch {
    return `${window.location.pathname}${window.location.search}`;
  }
};

export const trackAnalyticsEvent = async (input: {
  eventType: string;
  pagePath?: string;
  entityType?: string;
  entityId?: string;
  bookingId?: string;
  payload?: Record<string, unknown>;
}) => {
  if (typeof window === "undefined") return;

  const params = getUrlParams();
  const pagePath = input.pagePath || `${window.location.pathname}${window.location.search}`;

  try {
    await apiRequest("/analytics/track", {
      method: "POST",
      body: JSON.stringify({
        session_id: getAnalyticsSessionId(),
        event_type: input.eventType,
        page_path: pagePath,
        entity_type: input.entityType,
        entity_id: input.entityId,
        booking_id: input.bookingId,
        referrer: document.referrer || "",
        landing_path: getAnalyticsLandingPath(),
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        payload: input.payload || {},
      }),
    });
  } catch {
    // Analytics nunca deve quebrar a experiência principal.
  }
};
